<template>
  <div class="main" v-if="dialogTableVisible">
    <el-dialog
      title="Progress"
      width="80%"
      v-loading="loading"
      :visible.sync="dialogTableVisible"
      :close-on-click-modal="false"
      @close="closeDialog"
      :destroy-on-close="true"
      :modal-append-to-body="false"
    >
      <div
        class="dialog-content el-scrollbar"
        v-if="
          ordersDetails &&
          JSON.stringify(orderItem) !== '{}' &&
          JSON.stringify(ordersDetails) !== '{}'
        "
      >
        <div class="orders-status">
          <span>
            Status: {{ ordersDetails.status_en }}
            <span v-if="ordersDetails.abnormal && ordersDetails.abnormal.is_abnormal === 1">（{{ ordersDetails.abnormal }}）</span>
          </span>
        </div>
        <!-- 异常 -->
        <div
          class="abnormal-item"
          v-if="
            ordersDetails.status !== 99 &&
            ordersDetails.abnormal && ordersDetails.abnormal.is_abnormal === 1
          "
        >
          <div class="abnormal-content">
            <div
              v-for="(item, index) in ordersDetails.abnormal.abnormal_data"
              :key="index"
              class="wrap"
            >
              <p>
                <i class="el-icon-warning"></i> {{ item.abnormal_type_cn }}
                {{ item.create_time }}
              </p>
              <p
                v-for="(rItem, rkey, rIndex) in item.data"
                :key="rIndex"
                class="abnormal-reason"
              >
                <span class="blue">{{ rkey }}</span>
                <span class="goods-num">异常原因：</span>
                <span class="blue">{{ rItem }}</span>
              </p>
            </div>
          </div>
        </div>
        <!-- 冻结 -->
        <div
          class="hold-item"
          v-if="ordersDetails.status !== 99 && ordersDetails.hold && ordersDetails.hold.is_hold === 1"
        >
          <div class="hold-content">
            <p>
              <i class="el-icon-warning"></i> {{ ordersDetails.hold.name }}
              {{ ordersDetails.hold.date }}
            </p>
          </div>
        </div>
        <!-- 备注 -->
        <fieldset
          class="remark-item"
          v-if="
            orderItem.shipment_package_remark &&
            orderItem.shipment_package_remark.length > 0
          "
        >
          <legend>备注</legend>
          <div
            v-for="(pItem, pIndex) in orderItem.shipment_package_remark"
            :key="pIndex"
            class="remark-list"
          >
            <span>【{{ pItem.content }}】</span>
            <span>{{ pItem.create_time }}</span>
          </div>
        </fieldset>
        <!-- steps -->
        <!-- 修改当前步样式需要设置 :active="5" status="finish"(进行中设置蓝色) -->
        <div class="steps-item">
          <el-steps
            :space="200"
            :active="getStep(ordersDetails.status_text, 1)"
            finish-status="success"
            class="horizontal-steps"
          >
            <!-- <el-step
              :title="ordersDetails.create_time.name"
              :status="
                statusList[getStep(ordersDetails.status_text)].name ===
                ordersDetails.create_time.name
                  ? 'finish'
                  : ''
              "
            >
              <template slot="description">
                <p>{{ ordersDetails.create_time.date }}</p>
              </template>
            </el-step> -->
            <el-step
              v-if="ordersDetails.match"
              :title="statusList[0].name_en"
              :status="
                statusList[getStep(ordersDetails.status_text)].name ===
                ordersDetails.match.name
                  ? 'finish'
                  : ''
              "
            >
              <template slot="description">
                <p>{{ ordersDetails.match.date }}</p>
              </template>
            </el-step>
            <el-step
              v-if="ordersDetails.print"
              :title="statusList[1].name_en"
              :status="
                statusList[getStep(ordersDetails.status_text)].name ===
                ordersDetails.print.name
                  ? 'finish'
                  : ''
              "
            >
              <template slot="description">
                <p>{{ ordersDetails.print.date }}</p>
              </template>
            </el-step>
            <el-step
              v-if="ordersDetails.picking"
              :title="statusList[2].name_en"
              :status="
                statusList[getStep(ordersDetails.status_text)].name ===
                ordersDetails.picking.name
                  ? 'finish'
                  : ''
              "
            >
              <template slot="description">
                <p>{{ ordersDetails.picking.date }}</p>
              </template>
            </el-step>
            <!-- 加工 -->
            <el-step
              v-if="ordersDetails.process"
              :status="
                statusList[getStep(ordersDetails.status_text)].name ===
                ordersDetails.process.name
                  ? 'finish'
                  : ''
              "
              :title="statusList[3].name_en"
              style="flex-basis: 510px"
            >
              <div slot="title">
                <p>{{ statusList[3].name_en }}</p>
              </div>
              <i
                v-if="isAbnormal(ordersDetails.abnormal, 2)"
                slot="icon"
                class="el-icon-warning"
                style="color: #e04c38"
              ></i>
              <template slot="description">
                <p v-if="ordersDetails.process.date">
                  {{ ordersDetails.process.date }}
                </p>
                <p
                  v-if="
                    !ordersDetails.process.date &&
                    ordersDetails.status_text === '加工'
                  "
                >
                  ({{statusList[3].name_en}})
                </p>
                <el-steps
                  v-if="false"
                  direction="vertical"
                  :active="getLength(ordersDetails.process.process_data)"
                  class="vertical-steps"
                >
                  <div v-if="isShowAll">
                    <el-step
                      title=""
                      v-for="(item, key) in ordersDetails.process.process_data"
                      :key="key"
                    >
                      <div class="dot" slot="icon"></div>
                      <template slot="description">
                        <div style="display: flex">
                          <el-popover
                            placement="top"
                            width="400"
                            :trigger="item[0].user_process ? 'hover' : 'manual'"
                          >
                            <div
                              class="popover-content"
                              v-if="item[0].user_process"
                            >
                              <div
                                v-for="(uItem, uIndex) in item[0].user_process"
                                :key="uIndex"
                                class="user-item"
                              >
                                <div
                                  v-if="
                                    uIndex !== item[0].user_process.length - 1
                                  "
                                  class="line"
                                ></div>
                                <p class="dot"></p>
                                <div class="user-info">
                                  <p>
                                    {{ uItem.create_time }}
                                  </p>
                                  <div style="margin-left: 10px">
                                    <p
                                      v-for="(tItem, tIndex) in uItem.data"
                                      :key="tIndex"
                                    >
                                      {{ tItem.tech }}
                                      <el-tag
                                        v-if="tItem.is_second === 1"
                                        type="warning"
                                        >已二次加工</el-tag
                                      >
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <span class="sku-txt" slot="reference">{{
                              key
                            }}</span>
                          </el-popover>
                          <div style="margin-left: 5px">
                            <p
                              v-for="(sItem, sIndex) in item"
                              :key="sIndex"
                              style="margin-bottom: 5px"
                            >
                              <span>{{ sItem.tech }}</span>
                              <span style="margin-left: 5px">
                                <el-tag type="info" v-if="sItem.status === 2"
                                  >待完成</el-tag
                                >
                                <i
                                  class="el-icon-check"
                                  v-else-if="sItem.status === 1"
                                  style="color: #409eff; font-size: 16px"
                                ></i>
                                <i
                                  class="el-icon-warning"
                                  v-else-if="sItem.status === 50"
                                  style="color: #e04c38"
                                ></i>
                              </span>
                            </p>
                          </div>
                        </div>
                      </template>
                    </el-step>
                  </div>
                  <div v-if="!isShowAll">
                    <el-step
                      title=""
                      v-for="(item, key) in processProcessingData(
                        ordersDetails.process.process_data
                      )"
                      :key="key"
                    >
                      <div class="dot" slot="icon"></div>
                      <template slot="description">
                        <div style="display: flex">
                          <el-popover
                            placement="top"
                            width="400"
                            :trigger="item[0].user_process ? 'hover' : 'manual'"
                          >
                            <div
                              class="popover-content"
                              v-if="item[0].user_process"
                            >
                              <div
                                v-for="(uItem, uIndex) in item[0].user_process"
                                :key="uIndex"
                                class="user-item"
                              >
                                <div
                                  v-if="
                                    uIndex !== item[0].user_process.length - 1
                                  "
                                  class="line"
                                ></div>
                                <p class="dot"></p>
                                <div class="user-info">
                                  <p>
                                    {{ uItem.create_time }}
                                  </p>
                                  <div style="margin-left: 10px">
                                    <p
                                      v-for="(tItem, tIndex) in uItem.data"
                                      :key="tIndex"
                                    >
                                      {{ tItem.tech }}
                                      <el-tag
                                        v-if="tItem.is_second === 1"
                                        type="warning"
                                        >已二次加工</el-tag
                                      >
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <span class="sku-txt" slot="reference">{{
                              key
                            }}</span>
                          </el-popover>
                          <div style="margin-left: 5px">
                            <p
                              v-for="(sItem, sIndex) in item"
                              :key="sIndex"
                              style="margin-bottom: 5px"
                            >
                              <span>{{ sItem.tech }}</span>
                              <span style="margin-left: 5px">
                                <el-tag type="info" v-if="sItem.status === 2"
                                  >待完成</el-tag
                                >
                                <i
                                  class="el-icon-check"
                                  v-else-if="sItem.status === 1"
                                  style="color: #409eff; font-size: 16px"
                                ></i>
                                <i
                                  class="el-icon-warning"
                                  v-else-if="sItem.status === 3"
                                  style="color: #e04c38"
                                ></i>
                              </span>
                            </p>
                          </div>
                        </div>
                      </template>
                    </el-step>
                  </div>
                  <!-- <span
                    v-if="getLength(ordersDetails.process.process_data) > 2"
                    @click="isShowAll = !isShowAll"
                    style="color: #409eff"
                    ><i
                      :class="
                        isShowAll ? 'el-icon-arrow-up' : 'el-icon-arrow-down'
                      "
                    ></i>
                    {{ isShowAll ? "收起" : "查看全部" }}</span
                  > -->
                  <!-- <span v-if="isShowAll && getLength(ordersDetails.process.process_data) > 2" @click="isShowAll = !isShowAll" style="color: #409eff"><i class="el-icon-arrow-up"></i> 收起</span> -->
                </el-steps>
              </template>
            </el-step>
            <!-- 查货 -->
            <el-step
              v-if="ordersDetails.check"
              :title="statusList[4].name_en"
              :status="
                statusList[getStep(ordersDetails.status_text)].name ===
                ordersDetails.check.name
                  ? 'finish'
                  : ''
              "
              style="flex-basis: 280px"
            >
              <i
                v-if="isAbnormal(ordersDetails.abnormal, 3)"
                slot="icon"
                class="el-icon-warning"
                style="color: #e04c38"
              ></i>
              <template slot="description">
                <p>{{ ordersDetails.check.date }}</p>
                <el-steps
                  v-if="false"
                  direction="vertical"
                  :active="ordersDetails.check.check_data.length + 1"
                  class="vertical-steps"
                >
                  <div v-if="isShowAllTwo">
                    <el-step
                      title=""
                      v-for="(item, key) in ordersDetails.check.check_data"
                      :key="key"
                    >
                      <div class="dot" slot="icon"></div>
                      <template slot="description">
                        <div style="display: flex">
                          <el-popover
                            placement="top"
                            width="300"
                            :trigger="item.check_time ? 'hover' : 'manual'"
                          >
                            <div class="popover-content">
                              <p v-if="item.check_time">
                                查货时间：{{ item.check_time }}
                              </p>
                            </div>
                            <span class="sku-txt" slot="reference">
                              {{ item.sku }}
                            </span>
                          </el-popover>
                          <el-tag
                            v-if="item.delivery_type_cn"
                            :type="
                              [
                                '',
                                '',
                                'danger',
                                'warning',
                                'info',
                                '',
                                'warning',
                              ][item.delivery_type]
                            "
                            style="margin: 0 5px"
                            >{{ item.delivery_type_cn }}</el-tag
                          >
                          <span style="display: flex; flex-flow: column">
                            <el-tag
                              v-for="(oItem, index) in item.outsource_data"
                              :key="index"
                              style="margin-bottom: 5px"
                            >
                              {{ oItem }}
                            </el-tag>
                          </span>
                          <el-tag
                            type="info"
                            v-if="item.check_status === 2"
                            style="margin: 0 5px"
                          >
                            待查货
                          </el-tag>
                          <i
                            class="el-icon-check"
                            v-else-if="item.check_status === 1"
                            style="color: #409eff; font-size: 16px"
                          ></i>
                          <i
                            class="el-icon-warning"
                            v-else-if="item.check_status === 50"
                            style="color: #e04c38"
                          ></i>
                        </div>
                      </template>
                    </el-step>
                  </div>
                  <div v-if="!isShowAllTwo">
                    <el-step
                      title=""
                      v-for="(item, index) in processCheckData(
                        ordersDetails.check.check_data
                      )"
                      :key="index"
                    >
                      <div class="dot" slot="icon"></div>
                      <template slot="description">
                        <div style="display: flex">
                          <el-popover
                            placement="top"
                            width="300"
                            :trigger="item.check_time ? 'hover' : 'manual'"
                          >
                            <div class="popover-content">
                              <p v-if="item.check_time">
                                查货时间：{{ item.check_time }}
                              </p>
                            </div>
                            <span class="sku-txt" slot="reference">
                              {{ item.sku }}
                            </span>
                          </el-popover>
                          <el-tag
                            v-if="item.delivery_type_cn"
                            :type="
                              [
                                '',
                                '',
                                'danger',
                                'warning',
                                'info',
                                '',
                                'warning',
                              ][item.delivery_type]
                            "
                            style="margin: 0 5px"
                            >{{ item.delivery_type_cn }}</el-tag
                          >
                          <span style="display: flex; flex-flow: column">
                            <el-tag
                              v-for="(oItem, index) in item.outsource_data"
                              :key="index"
                              style="margin-bottom: 5px"
                            >
                              {{ oItem }}
                            </el-tag>
                          </span>
                          <el-tag
                            type="info"
                            v-if="item.check_status === 2"
                            style="margin: 0 5px"
                          >
                            待查货
                          </el-tag>
                          <i
                            class="el-icon-check"
                            v-else-if="item.check_status === 1"
                            style="color: #409eff; font-size: 16px"
                          ></i>
                          <i
                            class="el-icon-warning"
                            v-else-if="item.check_status === 50"
                            style="color: #e04c38"
                          ></i>
                        </div>
                      </template>
                    </el-step>
                  </div>
                  <!-- <span
                    v-if="ordersDetails.check.check_data.length > 2"
                    @click="isShowAllTwo = !isShowAllTwo"
                    style="color: #409eff"
                    ><i
                      :class="
                        isShowAllTwo ? 'el-icon-arrow-up' : 'el-icon-arrow-down'
                      "
                    ></i>
                    {{ isShowAllTwo ? "收起" : "查看全部" }}</span
                  > -->
                  <!-- <span v-if="isShowAllTwo && ordersDetails.check.check_data.length > 2" @click="isShowAllTwo = !isShowAllTwo" style="color: #409eff"><i class="el-icon-arrow-up"></i> 收起</span> -->
                </el-steps>
              </template>
            </el-step>
            <el-step
              v-if="ordersDetails.pack"
              :title="statusList[5].name_en"
              :status="
                statusList[getStep(ordersDetails.status_text)].name ===
                ordersDetails.pack.name
                  ? 'finish'
                  : ''
              "
            >
              <template slot="description">
                <p>{{ ordersDetails.pack.date }}</p>
              </template>
            </el-step>
            <el-step
              v-if="ordersDetails.weigh"
              :title="statusList[6].name_en"
              :status="
                statusList[getStep(ordersDetails.status_text)].name ===
                ordersDetails.weigh.name
                  ? 'finish'
                  : ''
              "
            >
              <template slot="description">
                <p>{{ ordersDetails.weigh.date }}</p>
              </template>
            </el-step>
            <el-step
              v-if="ordersDetails.ship"
              :title="statusList[7].name_en"
              :status="
                statusList[getStep(ordersDetails.status_text)].name ===
                ordersDetails.ship.name
                  ? 'finish'
                  : ''
              "
            >
              <template slot="description">
                <p>{{ ordersDetails.ship.date }}</p>
              </template>
            </el-step>
            <!-- 已取消 -->
            <el-step
              v-if="ordersDetails.status === 99"
              :title="statusList[8].name_en"
              status="finish"
            >
              <p slot="title" style="color: red">
                {{ statusList[8].name_en }}
              </p>
              <template slot="description">
                <p style="color: red">{{ ordersDetails.cancel.date }}</p>
              </template>
            </el-step>
          </el-steps>
        </div>
      </div>
      <el-empty v-else-if="!loading" description="No progress data"></el-empty>
      <div slot="footer" class="dialog-footer">
        <el-button v-waves size="small" @click="closeDialog">Close</el-button>
      </div>
    </el-dialog>

    <!-- <el-button
      class="icon-cangku iconfont_action"
      size="mini"
      type="text"
      slot="reference"
      style="padding: 0; margin-left: 8px"
      @click="changeData"
      >仓库进度</el-button
    > -->
  </div>
</template>

<script>
// import { mapGetters } from "vuex";
import { cmofferApi } from "@/http/cmofferApi";

export default {
  name: "wmsSteps",
  data() {
    return {
    //   isShowDialog: false,
      orderItem: {},
      ordersDetails: {},
      activeNames: ["1", "2", "3"],
      statusList: [
        // 数组最后一个防止订单最后一步的时候报错
        // {
        //   name: "创建时间",
        //   index: 0,
        // },
        {
          name: "配货",
          name_en: "Matched",
          index: 0,
        },
        {
          name: "打印",
          name_en: "Printed",
          index: 1,
        },
        {
          name: "拣货出库",
          name_en: "Picked",
          index: 2,
        },
        {
          name: "加工",
          name_en: "Processed",
          index: 3,
        },
        {
          name: "查货",
          name_en: "Checked",
          index: 4,
        },

        {
          name: "打包",
          name_en: "Packaged",
          index: 5,
        },
        {
          name: "称重",
          name_en: "Weighted",
          index: 6,
        },
        {
          name: "发货完成",
          name_en: "Shipped",
          index: 7,
        },
        {
          name: "已取消",
          name_en: "Cancelled",
          index: 8,
        },
        {
          name: "",
          index: 9,
        },
      ],
      isShowAll: true,
      isShowAllTwo: true,
      loading: true,
    };
  },
  props: {
    dialogTableVisible: Boolean,
    orderItem: Object,
  },
  watch: {
    dialogTableVisible(val) {
      if (val) {
        this.changeData(val);
      } else {
        // this.isShowDialog = this.isShowAll = false;
        this.orderItem = this.ordersDetails = {};
      }
    },
  },
  computed: {
    // ...mapGetters(["sellOutDeliveryInfo"]),
  },
  mounted() {
  },
  methods: {
    isAbnormal(abnormal, ty) {
      if (abnormal.is_abnormal !== 1) return false;
      if (abnormal.abnormal_data.length > 0)
        return abnormal.abnormal_data[0].abnormal_type === ty ? true : false;
      else return false;
    },
    processCheckData(data) {
      let i = 0;
      let dd = [];
      for (let d of data) {
        i++;
        if (i <= 2) {
          dd.push(d);
        }
      }
      return dd;
    },
    processProcessingData(data) {
      if (Object.keys(data).length <= 2) return data;
      let i = 0;
      let dd = {};
      for (var key in data) {
        i++;
        dd[key] = data[key];
        if (i === 2) return dd;
      }
    },
    getStep(status_text) {
      return (
        this.statusList.findIndex((d) => {
          return d.name == status_text;
        }) + 1
      );
      // for (let d of this.statusList) {
      //   if (d.name == status_text) {
      //     return d.index + 1;
      //   }
      // }
    },
    getLength(data) {
      return Object.keys(data).length;
    },
    // 关闭Dialog
    closeDialog() {
      this.$emit("update:dialogTableVisible", false);
    },
    // 数据发生改变执行操作
    changeData() {
      this.getOrdersDetails();
    },
    getOrdersDetails() {
      this.loading = true
      cmofferApi
        .wmsSteps(
          {
            sn: this.orderItem.plt_order_sn,
            shop_id: this.orderItem.erp_shop_id,
          },
          "get"
        )
        .then((res) => {
          this.loading = false
          if (res.data && JSON.stringify(res.data) !== "[]") {
            this.ordersDetails = res.data;
            // this.isShowDialog = true;
          } else {
            this.ordersDetails = null;
            // this.$message.warning(res.msg);
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.el-dialog {
  /* 修改el-dialog的title样式 */
  .el-dialog__header {
    padding: 10px 20px 5px;
  }
  .el-dialog__body {
    padding: 15px 20px;
  }
}
</style>

<style lang="scss" scoped>
.main {
  .dialog-content {
    height: 60vh;
    max-height: 300px;
    overflow: auto;
    text-align: left;
    div {
      table {
        width: 100%;
        border-collapse: collapse;
        font-size: 12px;
        td {
          height: 32px;
          border: 1px solid #eef2fe;
          padding: 1px 3px;
        }
        .td-bg {
          background: #eef2fe;
          width: 100px;
          text-align: right;
        }
        .td-w {
          width: 150px;
          text-align: left;
        }
      }
    }
    .table-center {
      table {
        td {
          padding: 3px 5px;
          text-align: center;
        }
      }
    }
    .orders-status {
      padding: 10px 20px;
      background: #eef2fe;
      span {
        font-size: 18px;
        font-weight: bold;
      }
    }
    .abnormal-item {
      margin: 20px 0;
      .abnormal-content {
        width: 95%;
        border-radius: 4px;
        border: 1px solid #e04c38;
        background: #f8e5e5;
        padding: 10px;
        .wrap {
          margin-bottom: 10px;
          .el-icon-warning {
            color: #e04c38;
          }
          .abnormal-reason {
            margin-left: 15px;
            .goods-num {
              margin-left: 20px;
            }
            .blue {
              color: #409eff;
            }
          }
        }
      }
    }
    .hold-item {
      margin: 20px 0;
      .hold-content {
        width: 95%;
        border-radius: 4px;
        border: 1px solid #e04c38;
        background: #f8e5e5;
        padding: 10px;
        .el-icon-warning {
          color: #e04c38;
        }
      }
    }
    .remark-item {
      border: 1px solid #e6a23c;
      background: #fdf6ec;
      width: 95%;
      border-radius: 4px;
      .remark-list {
        line-height: 20px;
      }
    }
    .steps-item {
      margin: 20px 0;
      .horizontal-steps {
        ::v-deep .el-step__head.is-success {
          color: #409eff;
          border-color: #409eff;
          .el-step__line {
            background-color: #409eff;
          }
        }
        ::v-deep .el-step__main {
          white-space: nowrap;
          .el-step__title.is-success {
            color: #303133;
          }
          .el-step__description.is-success {
            color: #4b5d6c;
          }
        }
        ::v-deep .el-step__head.is-wait {
          color: #303133;
          border-color: #303133;
        }
        ::v-deep .el-step__title.is-wait {
          color: #303133;
        }
        // 解决竖步骤条最后一个不对齐问题
        ::v-deep .el-step__description {
          padding-right: 0;
        }
        ::v-deep .el-step__description.is-wait {
          color: #4b5d6c;
        }
        // 进行中的字体颜色
        ::v-deep .el-step__title.is-finish {
          color: #4b5d6c;
        }
        ::v-deep .el-step__description.is-finish {
          color: #4b5d6c;
        }
        // 解决嵌套步骤条里面那个竖线不展示问题
        .vertical-steps {
          margin-left: 12px;
          ::v-deep .el-step {
            margin-bottom: 0;
            margin-right: 10px;
            .el-step__description.is-finish {
              color: #4b5d6c;
              .sku-txt {
                color: #409eff;
              }
            }
          }
          ::v-deep .el-step__icon {
            // top: -10px;
            width: 8px;
            height: 8px;
            background: #409eff;
          }
          ::v-deep .el-step__line {
            width: 1px;
            height: 100%;
            left: 3px;
            top: 13px;
          }
        }
      }
    }
    .el-collapse {
      ::v-deep .el-collapse-item__header {
        font-size: 16px;
      }
    }
    .el-tag {
      border-radius: 4px;
      font-size: 12px;
      height: 24px;
      padding: 0 8px;
      line-height: 22px;
    }
    .el-tag.el-tag--info {
      background-color: #f4f4f5;
      border-color: #e9e9eb;
      color: #909399 !important;
    }
    .orders-cost {
      background: #eef2fe;
      text-align: right;
      padding: 10px 20px;
    }
  }
}
.dialog-footer {
  text-align: center;
  line-height: 60px;
}

// popover弹框steps
.popover-content {
  .user-item {
    position: relative;
    display: flex;
    padding-bottom: 10px;
    .dot {
      width: 5px;
      height: 5px;
      border-radius: 50%;
      background: #606266;
      margin-top: 6px;
    }
    .user-info {
      margin-left: 20px;
      display: flex;
    }
    .line {
      position: absolute;
      background: #606266;
      height: 100%;
      width: 1px;
      margin-left: 2px;
      margin-top: 6px;
    }
  }
}
</style>